import useModal from "../../../useModal";
import Modalheader from "../../../components/header";
import ModalBody from "../../../components/body";
import ModalFooter from "../../../components/footer";
import Button from "../../../../button";
import UseContext from "../../../../../hooks/useContext";
import React, { useEffect, useState, useRef, useCallback } from "react";
import ApiDatabase from "server";
import StyledInput from "../../../../styledInput/StyledInput";
import { CheckIcon } from "assets/icons";

const ModalMissionCompanyCancel = () => {
  const { toggle } = useModal();
  const { objID, setMissionStatusUpdate } = UseContext();
  const [step, setStep] = useState(1);
  const [isWaiting, setIsWaiting] = useState(true);
  const [missionData, setMissionData] = useState(null);
  const [reasons, setReasons] = useState([]);
  const [reasonSelected, setReasonSelected] = useState("");
  const [countdown, setCountdown] = useState(3);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const timerRef = useRef(null);
  const intervalRef = useRef(null);
  useEffect(() => {
    if (objID) {
      setIsWaiting(true);
      ApiDatabase.getCompanyMissionStatusInfo(
        { idMission: objID },
        (data) => {
          setMissionData(data.mission);
          setReasons(data.reasons || []);
          setIsWaiting(false);
        },
        (err) => {
          console.error(err);
          setIsWaiting(false);
        }
      );
    }
  }, [objID]);

  const clearTimers = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (intervalRef.current) clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    return () => clearTimers();
  }, [clearTimers]);

  const startCountdown = () => {
    setStep(2);
    setCountdown(3);
    setIsSubmitted(false);

    intervalRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    timerRef.current = setTimeout(() => {
      submitAction();
    }, 3000);
  };

  const submitAction = () => {
    setIsSubmitted(true);
    ApiDatabase.postCompanyMissionStatusChange(
      {
        idMission: objID,
        newStatus: "canceled",
        reason: reasonSelected,
      },
      () => {
        setMissionStatusUpdate({ status: "canceled" });
      },
      (err) => console.error("Error canceling mission:", err)
    );
  };

  const handleCancelCountdown = () => {
    clearTimers();
    setStep(1);
    setCountdown(3);
  };

  const selectList = [
    { value: "", label: "Sélectionner" },
    ...reasons.map((r) => ({ value: r.name, label: r.name })),
  ];

  if (step === 2) {
    return (
      <>
        <ModalBody>
          <div className="flex flex-col gap-4 items-center text-center py-4">
            <div className="flex items-center justify-center w-24 h-24 rounded-full bg-green-100">
              <CheckIcon w={32} h={32} color="#111827" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900">
              Mission Annulée
            </h2>
            <p className="text-gray-600">
              Nous avons informé l'agence que cette mission a été annulée
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          {isSubmitted ? (
            <Button size="LG" color="SECONDARY" onClick={toggle}>
              Retour
            </Button>
          ) : (
            <Button size="LG" color="SECONDARY" onClick={handleCancelCountdown}>
              Annuler ({countdown} s)
            </Button>
          )}
        </ModalFooter>
      </>
    );
  }

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Annuler la mission
      </Modalheader>
      <ModalBody>
        {isWaiting ? (
          <div className="animate-pulse flex flex-col gap-3">
            <div className="h-4 bg-gray-200 rounded w-3/4" />
            <div className="h-10 bg-gray-200 rounded" />
          </div>
        ) : (
          <div className="flex flex-col gap-4">
            <p className="text-gray-700">
              Vous pouvez annuler cette mission car aucun profil n'est
              actuellement assigné
            </p>
            <StyledInput
              type="select"
              label="Motif"
              placeholder="Sélectionner"
              value={reasonSelected}
              onChange={(e) => setReasonSelected(e.target.value)}
              list={selectList}
            />
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button size="LG" color="SECONDARY" onClick={toggle}>
          Retour
        </Button>
        {!reasonSelected ? (
          <Button size="LG" color="DISABLED">
            Confirmer
          </Button>
        ) : (
          <Button size="LG" color="PRIMARY" onClick={startCountdown}>
            Confirmer
          </Button>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalMissionCompanyCancel;
